import { render, staticRenderFns } from "./communication-state.vue?vue&type=template&id=36fe1c5d&scoped=true"
import script from "./communication-state.vue?vue&type=script&lang=js"
export * from "./communication-state.vue?vue&type=script&lang=js"
import style0 from "./communication-state.vue?vue&type=style&index=0&id=36fe1c5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fe1c5d",
  null
  
)

export default component.exports